/* PupTailor "View photo".
   - Rebuy Smart Cart / theme cart page: an uploaded-photo property shows as a "View photo" link
     (instead of the raw file URL) and opens a photo viewer with a clear close button.
   - Product page: Globo's uploaded-file card opens the same viewer instead of a new tab, and shows the
     shopper's own photo immediately while Globo's copy loads.
   - A small copy of the shopper's photo (about 1080px) is kept in this browser, keyed by the uploaded
     file's URL, so "View photo" in the cart opens at once instead of downloading the full-size original.
   - Before Globo uploads a photo, it is shrunk on the shopper's device to at most 2048px on the long
     edge (production approved, 2026-10-01), so the upload takes a fraction of the time.
   Cart and order data (line item properties) are never changed. */
(function () {
  if (window.ptPhotoPreview) return;
  window.ptPhotoPreview = true;

  var IMG = /^https?:\/\/\S+\.(jpe?g|png|webp|gif|heic|heif)(\?\S*)?$/i;
  var UPLOAD = /^https?:\/\/\S+\/uploads\/\S+$/i;
  function isPhoto(url) {
    url = (url || '').trim();
    return IMG.test(url) || UPLOAD.test(url);
  }

  var css = [
    '.rebuy-cart__flyout-item-property-value{overflow-wrap:anywhere;word-break:break-word}',
    '.rebuy-cart__flyout-item-property-value[data-pt-photo]{display:inline-block;font-size:0!important;line-height:0!important;color:transparent!important;cursor:pointer;vertical-align:baseline}',
    '.rebuy-cart__flyout-item-property-value[data-pt-photo]::after{content:"View photo";font:600 13px/1.5 "Nunito Sans",Arial,sans-serif;color:#18304a;text-decoration:underline;text-underline-offset:2px}',
    '.rebuy-cart__flyout-item-property-value[data-pt-photo]:focus-visible{outline:2px solid #18304a;outline-offset:2px}',
    '.pt-photo-dialog{width:min(560px,calc(100vw - 32px));max-width:none;max-height:calc(100dvh - 32px);margin:auto;padding:0;border:0;background:#fff;color:#26394a;box-shadow:0 12px 40px rgba(0,0,0,.25)}',
    '.pt-photo-dialog::backdrop{background:rgba(20,26,32,.62)}',
    '.pt-photo-dialog__inner{display:flex;flex-direction:column;gap:12px;padding:16px 16px 18px;max-height:calc(100dvh - 32px);box-sizing:border-box}',
    '.pt-photo-dialog__head{display:flex;align-items:center;justify-content:space-between;gap:12px}',
    '.pt-photo-dialog__title{margin:0;font:600 18px/1.3 Lora,Georgia,serif;color:#18304a}',
    '.pt-photo-dialog__x{flex:0 0 44px;width:44px;height:44px;display:inline-flex;align-items:center;justify-content:center;border:1px solid #d0d3d6;background:#fff;color:#18304a;cursor:pointer;padding:0}',
    '.pt-photo-dialog__x svg{width:18px;height:18px}',
    '.pt-photo-dialog__x:focus-visible,.pt-photo-dialog__back:focus-visible{outline:2px solid #18304a;outline-offset:2px}',
    '.pt-photo-dialog__frame{position:relative;display:flex;align-items:center;justify-content:center;min-height:200px;background:#f3f3f3;overflow:hidden}',
    '.pt-photo-dialog__frame img{display:block;max-width:100%;max-height:min(62dvh,560px);object-fit:contain}',
    '.pt-photo-dialog__status{position:absolute;margin:0;font:400 14px/1.5 "Nunito Sans",Arial,sans-serif;color:#5a6570}',
    '.pt-photo-dialog__status a{color:#18304a}',
    '.pt-photo-dialog__note{margin:0;font:400 14px/1.5 "Nunito Sans",Arial,sans-serif;color:#5a6570}',
    '.pt-photo-dialog__back{min-height:52px;border:0;background:#18304a;color:#fff;font:700 14px/1 "Nunito Sans",Arial,sans-serif;letter-spacing:.1em;text-transform:uppercase;cursor:pointer}',
    'html.pt-photo-open{overflow:hidden}'
  ].join('\n');
  var style = document.createElement('style');
  style.id = 'pt-photo-preview-css';
  style.textContent = css;
  (document.head || document.documentElement).appendChild(style);

  /* Small local copies of uploaded photos: newest first, a few at most, dropped after 14 days
     (the cart's own lifetime). Storage can be unavailable or full; the viewer then loads the original. */
  var STORE = 'pt-photo-previews';
  var KEEP = 4;
  var MAX_AGE = 14 * 864e5;
  var EDGE = 1080;
  function readStore() {
    try {
      var list = JSON.parse(localStorage.getItem(STORE) || '[]');
      var now = Date.now();
      return Array.isArray(list) ? list.filter(function (x) { return x && x.u && x.d && now - x.t < MAX_AGE; }) : [];
    } catch (e) { return []; }
  }
  function savedCopy(url) {
    var list = readStore();
    for (var i = 0; i < list.length; i++) if (list[i].u === url) return list[i].d;
    return null;
  }
  function saveCopy(url, data) {
    var list = readStore().filter(function (x) { return x.u !== url; });
    list.unshift({ u: url, d: data, t: Date.now() });
    list = list.slice(0, KEEP);
    while (list.length) {
      try { localStorage.setItem(STORE, JSON.stringify(list)); return; } catch (e) { list.pop(); }
    }
    try { localStorage.removeItem(STORE); } catch (e) {}
  }
  /* Downscaled JPEG of an already decoded image; null if the browser could not draw it. */
  function smallCopy(im) {
    try {
      var w = im.naturalWidth, h = im.naturalHeight, k = Math.min(1, EDGE / Math.max(w, h));
      var c = document.createElement('canvas');
      c.width = Math.max(1, Math.round(w * k));
      c.height = Math.max(1, Math.round(h * k));
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#fff';
      ctx.fillRect(0, 0, c.width, c.height);
      ctx.drawImage(im, 0, 0, c.width, c.height);
      var px = ctx.getImageData(0, 0, c.width, c.height).data, step = Math.max(4, Math.floor(px.length / 4 / 400) * 4), blank = true;
      for (var i = 0; i < px.length; i += step) { if (px[i] < 250 || px[i + 1] < 250 || px[i + 2] < 250) { blank = false; break; } }
      if (blank) return null;
      var data = c.toDataURL('image/jpeg', 0.8);
      return data.length < 700000 ? data : null;
    } catch (e) { return null; }
  }
  /* Once Globo shows the uploaded file, remember the small copy under its URL. */
  function keepCopy(el) {
    if (!el.ptSmall) return;
    var a = el.querySelector('.gpo-f-card .gpo-f-link[href]');
    var url = a && a.getAttribute('href');
    if (!url || url === el.ptSavedFor || !isPhoto(url)) return;
    el.ptSavedFor = url;
    saveCopy(url, el.ptSmall);
  }

  var dlg, img, statusEl, noteEl, backBtn, opener;
  function build() {
    if (dlg) return;
    dlg = document.createElement('dialog');
    dlg.className = 'pt-photo-dialog';
    dlg.setAttribute('aria-labelledby', 'pt-photo-title');
    dlg.innerHTML =
      '<div class="pt-photo-dialog__inner">' +
      '<div class="pt-photo-dialog__head"><h2 class="pt-photo-dialog__title" id="pt-photo-title">Your uploaded photo</h2>' +
      '<button type="button" class="pt-photo-dialog__x" aria-label="Close"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg></button></div>' +
      '<div class="pt-photo-dialog__frame"><img alt="Your uploaded photo"><p class="pt-photo-dialog__status" role="status"></p></div>' +
      '<p class="pt-photo-dialog__note"></p>' +
      '<button type="button" class="pt-photo-dialog__back"></button>' +
      '</div>';
    document.body.appendChild(dlg);
    img = dlg.querySelector('img');
    statusEl = dlg.querySelector('.pt-photo-dialog__status');
    noteEl = dlg.querySelector('.pt-photo-dialog__note');
    backBtn = dlg.querySelector('.pt-photo-dialog__back');
    dlg.querySelector('.pt-photo-dialog__x').addEventListener('click', close);
    backBtn.addEventListener('click', close);
    dlg.addEventListener('click', function (e) { if (e.target === dlg) close(); });
    dlg.addEventListener('close', function () {
      document.documentElement.classList.remove('pt-photo-open');
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    });
    img.addEventListener('load', function () { statusEl.textContent = ''; img.style.visibility = 'visible'; });
    img.addEventListener('error', function () {
      statusEl.innerHTML = 'We couldn’t load this photo. <a target="_blank" rel="noopener">Open it in a new tab</a>';
      statusEl.querySelector('a').href = img.getAttribute('src');
    });
  }
  function open(url, from, trigger, localUrl) {
    build();
    opener = trigger || document.activeElement;
    var inCart = from === 'cart';
    noteEl.textContent = inCart
      ? 'Need a different photo? Remove this item and add it again with the new one.'
      : 'Need a different photo? Remove it and upload a new one.';
    backBtn.textContent = inCart ? 'Back to cart' : 'Close';
    statusEl.textContent = 'Loading photo…';
    img.style.visibility = 'hidden';
    img.removeAttribute('src');
    img.onerror = null;
    if (localUrl) img.onerror = function () { img.onerror = null; img.src = url; };
    img.src = localUrl || url;
    document.documentElement.classList.add('pt-photo-open');
    if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', '');
    dlg.querySelector('.pt-photo-dialog__x').focus({ preventScroll: true });
  }
  function close() {
    if (!dlg) return;
    if (dlg.close) dlg.close(); else { dlg.removeAttribute('open'); document.documentElement.classList.remove('pt-photo-open'); }
  }

  /* Rebuy Smart Cart: mark photo properties (the URL is read again at click time). */
  function markCart() {
    var vals = document.querySelectorAll('.rebuy-cart__flyout-item-property-value:not([data-pt-photo])');
    for (var i = 0; i < vals.length; i++) {
      var el = vals[i];
      if (!isPhoto(el.textContent)) continue;
      el.setAttribute('data-pt-photo', '');
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.setAttribute('aria-label', 'View your uploaded photo');
    }
    /* Theme cart page: links to uploaded photos */
    var links = document.querySelectorAll('.cart-item .product-option a[href]:not([data-pt-photo])');
    for (var j = 0; j < links.length; j++) {
      var a = links[j];
      if (!isPhoto(a.getAttribute('href'))) continue;
      a.setAttribute('data-pt-photo', '');
      a.textContent = 'View photo';
    }
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var cartVal = t.closest('.rebuy-cart__flyout-item-property-value[data-pt-photo]');
    if (cartVal) { e.preventDefault(); openCart(cartVal.textContent.trim(), cartVal); return; }
    var cartLink = t.closest('.cart-item .product-option a[data-pt-photo]');
    if (cartLink) { e.preventDefault(); openCart(cartLink.getAttribute('href'), cartLink); return; }
    var hit = t.closest('.gpo-f-card .gpo-f-link, .gpo-f-card .gpo-f-name');
    var card = hit && hit.closest('.gpo-f-card').querySelector('.gpo-f-link[href]');
    if (card) {
      e.preventDefault();
      var el = card.closest('.gpo-element');
      open(card.getAttribute('href'), 'pdp', card, el && el.ptLocalPreview);
    }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var cartVal = e.target && e.target.closest && e.target.closest('.rebuy-cart__flyout-item-property-value[data-pt-photo]');
    if (cartVal) { e.preventDefault(); openCart(cartVal.textContent.trim(), cartVal); }
  });
  function openCart(url, trigger) { open(url, 'cart', trigger, savedCopy(url)); }

  /* Upload size: shrink a picked photo to at most 2048px on the long edge before Globo uploads it
     (JPEG 0.9; PNG when the picture has transparency). Photos already within 2048px and 1.5 MB pass
     unchanged. Any failure, or more than 6 s, falls back to the original file, so an upload is never
     blocked. Globo then receives the file through the usual input/change events. */
  var MAX_EDGE = 2048;
  var KEEP_BYTES = 1.5 * 1024 * 1024;
  function shrinkFile(file) {
    return new Promise(function (resolve) {
      if (!/^image\/(jpeg|pjpeg|png|webp|heic|heif)$/i.test(file.type || '')) return resolve(file);
      var src = URL.createObjectURL(file);
      var im = new Image();
      var settled = false;
      var timer = setTimeout(function () { done(file); }, 6000);
      function done(f) {
        if (settled) return;
        settled = true;
        clearTimeout(timer);
        URL.revokeObjectURL(src);
        resolve(f || file);
      }
      im.onerror = function () { done(file); };
      im.onload = function () {
        try {
          var w = im.naturalWidth, h = im.naturalHeight, k = Math.min(1, MAX_EDGE / Math.max(w, h));
          if (!w || !h || (k === 1 && file.size <= KEEP_BYTES)) return done(file);
          var c = document.createElement('canvas');
          c.width = Math.max(1, Math.round(w * k));
          c.height = Math.max(1, Math.round(h * k));
          var ctx = c.getContext('2d');
          ctx.drawImage(im, 0, 0, c.width, c.height);
          var px = ctx.getImageData(0, 0, c.width, c.height).data;
          var step = Math.max(4, Math.floor(px.length / 4 / 3000) * 4), alpha = false, lo = 255, hi = 0;
          for (var i = 0; i < px.length; i += step) {
            if (px[i + 3] < 250) alpha = true;
            if (px[i] < lo) lo = px[i];
            if (px[i] > hi) hi = px[i];
          }
          if (hi - lo < 4 && !alpha) return done(file); /* nothing drawn (device limits): keep the original */
          var type = alpha ? 'image/png' : 'image/jpeg';
          c.toBlob(function (blob) {
            if (!blob || blob.size >= file.size) return done(file);
            var name = (file.name || 'photo').replace(/\.[^.]*$/, '') + (alpha ? '.png' : '.jpg');
            try { done(new File([blob], name, { type: type, lastModified: Date.now() })); } catch (err) { done(file); }
          }, type, 0.9);
        } catch (err) { done(file); }
      };
      im.src = src;
    });
  }
  function onFilePicked(e) {
    var input = e.target;
    if (!input || input.type !== 'file' || !input.closest || !input.closest('.gpo-element')) return;
    if (input.ptPass > 0) { input.ptPass--; return; } /* our own re-dispatch: Globo and the preview take it */
    if (!input.files || !input.files.length || !window.Promise || !window.DataTransfer || !window.URL || !URL.createObjectURL) return;
    e.stopImmediatePropagation();
    var files = Array.prototype.slice.call(input.files);
    var sig = files.map(function (f) { return f.name + ':' + f.size + ':' + f.lastModified; }).join('|');
    if (input.ptJob && input.ptJob.sig === sig) return; /* input + change of the same pick */
    var job = input.ptJob = { sig: sig };
    Promise.all(files.map(shrinkFile)).then(function (out) {
      if (input.ptJob !== job) return; /* a newer pick replaced this one */
      input.ptJob = null;
      if (out.some(function (f, i) { return f !== files[i]; })) {
        try {
          var dt = new DataTransfer();
          out.forEach(function (f) { dt.items.add(f); });
          input.files = dt.files;
        } catch (err) { /* keep the original files */ }
      }
      input.ptPass = 2;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  document.addEventListener('input', onFilePicked, true);
  document.addEventListener('change', onFilePicked, true);

  /* Product page: show the shopper's own photo right away, once this browser can display it
     (otherwise Globo's own thumbnail is used), and make the small copy for the cart. */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'file' || !input.files || !input.closest) return;
    var el = input.closest('.gpo-element');
    if (!el) return;
    if (el.ptLocalPreview) URL.revokeObjectURL(el.ptLocalPreview);
    el.ptLocalPreview = el.ptSmall = el.ptSavedFor = null;
    el.style.removeProperty('--pt-local-preview');
    el.removeAttribute('data-pt-local-preview');
    var file = input.files.length === 1 ? input.files[0] : null;
    if (!file || !/^image\//.test(file.type) || !window.URL || !URL.createObjectURL) return;
    var src = URL.createObjectURL(file);
    var im = new Image();
    im.onload = function () {
      if (input.files[0] !== file) { URL.revokeObjectURL(src); return; }
      el.ptLocalPreview = src;
      el.style.setProperty('--pt-local-preview', 'url("' + src + '")');
      el.setAttribute('data-pt-local-preview', '');
      el.ptSmall = smallCopy(im);
      keepCopy(el);
    };
    im.onerror = function () { URL.revokeObjectURL(src); };
    im.src = src;
  }, true);

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      markCart();
      var els = document.querySelectorAll('.gpo-element[data-pt-local-preview]');
      for (var i = 0; i < els.length; i++) keepCopy(els[i]);
    });
  }
  if (window.MutationObserver) new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', markCart); else markCart();
})();
